<template>
  <div class='task-question question-review'>


    <el-table :data="table"
              stripe
              highlight-current-row
              :show-header='false'
              class='margin b15'
              style='width: 100%;padding: 30px 0 15px 15px;'>

        <el-table-column width='250' v-for="index of columnNum" :key="index">
          <template slot-scope="scope">
            {{scope.row[index-1]}}
          </template>
        </el-table-column>
    </el-table>
  </div>
</template>

<script>
import '@views/question-review/question-review.scss'
import SjQuestionGuideVideo from '@/views/question-editor/components/SjQuestionGuideVideo'
import AnswerFile from '@/views/question-review/packages/AnswerFileList/AnswerFile'

export default {
  components: {SjQuestionGuideVideo, AnswerFile},
  mixins: [],
  inject: ['page'],
  props: {},
  data () {
    return {
      liveData: {},
      res: [],
      line: 0,
      temp: [],
      columnNum: 3,
      table: []
    }
  },
  computed: {},
  watch: {},
  beforeCreate () {},
  created () {},
  mounted () {
    this.page.questionContainerElement = this.$el
    this.getOrderLiveDetail(this.page.id)
  },
  methods: {
    getOrderLiveDetail (id) {
      request.dispatch('getOrderLiveDetail', {id}).then((res) => {
        if (res.data) {
          this.liveData = res.data.data.data.execution_results

          this.getData(this.liveData)
          this.table = this.res
        }
      })
    },
    getData (data, i = 0) {
      if (!data) {
        data = this.liveData
      }
      if (i > this.columnNum - 2) {
        this.columnNum++
      }

      for (let key in data) {
        if (data === this.liveData) {
          i = 0
        }
        if (data.hasOwnProperty(key)) {
          if (this.res[this.line] === undefined) {
            this.res[this.line] = []
            if (i > 0) {
              for (let j = 0; j < i; j++) {
                // this.res[this.line].push(this.res[this.line - 1][j])
                this.res[this.line].push('')
              }
            }
          }

          if (data[key].constructor === Object) {
            this.res[this.line].push(key)
            i++
            this.getData(data[key], i)
          } else {
            this.res[this.line].push(key)
            if (JSON.stringify(data[key]) === '[]' && data[key].length === 0) {
              this.res[this.line].push('')
            } else {
              this.res[this.line].push(data[key])
            }
            this.line++
          }
        }
      }
    },
  },
}
</script>
<style lang='scss'
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
.task-question {
  width: 100%;
  /*overflow: hidden;*/
  height: 100%;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/views/order-review/pages/OrderLiveReviewPanel/index.vue